'use strict';

module.exports = function getUserAgent() {
  return global.navigator.userAgent;
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/client/request/get-user-agent.js
// module id = 798
// module chunks = 0